import { PageLayout } from '~/components/Layout/PageLayout';
import { PAGE_CONTENT_TOP } from '~/components/Layout/PageLayout';
import { useT } from '~/i18n/LocaleContext';

export default function CpcTradePage() {
	const t = useT();
	return (
		<PageLayout
			content={
				<div className={PAGE_CONTENT_TOP}>
					<div className="mx-auto flex min-h-[56vh] max-w-xl items-center justify-center px-4">
						<div className="w-full rounded-2xl border border-white/15 bg-[#0F172A] px-8 py-14 text-center">
							<p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#38BDF8]">
								{t('nav.dex')}
							</p>
							<h1 className="mt-4 text-2xl font-semibold text-white md:text-3xl">
								{t('trade.maintTitle')}
							</h1>
							<p className="mt-3 text-sm leading-6 text-[#94a3b8] md:text-base">
								{t('trade.maintEta')}
							</p>
						</div>
					</div>
				</div>
			}
		/>
	);
}
